import styled, {css} from "styled-components"
import Selector, {SelectorProps} from "@irati/ui/src/Selector"
import Slider from "@irati/ui/src/Slider"
import {Label} from "@irati/ui/src/Typography"
import Flex from "@irati/ui/src/Flex"

interface SelectorComponentProps extends SelectorProps {
  selected: boolean | undefined
  selectorBgColor: string
  iconBgColor: string
  svgData?: string
}

export const StyledSelector = styled(Selector)<SelectorComponentProps>`
  ${({theme, selected, selectorBgColor}) => css`
    background-color: ${selected ? selectorBgColor : theme.colors.utility.white};
    border: 2px solid ${selected ? selectorBgColor : theme.colors.primary2_50};
    width: 100%;
    height: 118px;
    margin-right: ${theme.spacing.two};

    &:hover {
      background-color: ${selectorBgColor};
      border-color: ${selectorBgColor};
      box-shadow: ${theme.shadows.low};
      color: ${theme.colors.utility.white};
      ${Label} {
        color: ${theme.colors.utility.white};
      }

      path {
        fill: ${theme.colors.primary2};
      }
    }

    &:focus {
      ${Label} {
        color: ${selected && theme.colors.utility.white};
      }
      background-color: ${selected && selectorBgColor};
      color: ${selected && theme.colors.utility.white};
      path {
        fill: ${theme.colors.primary2};
      }
    }
  `}
`

export const CategorySlider = styled(Slider)<SelectorComponentProps>`
  display: none !important;
  ${({theme}) => css`
    ${theme.mediaQueries.maxWidthMedia.tablet`
      display: block !important;
    `}
  `}
`

export const WellnessCategoriesWrapper = styled(Flex)`
  ${({theme}) => css`
    flex-direction: column;
    color: ${theme.colors.greys.black};
    font-family: ${theme.font.medium};
    font-size: 10px;
    font-weight: bold;
    text-transform: capitalize;
    margin: 0 1px;
    line-height: 12px;
    display: flex;
  `}
`

export const Divider = styled.div`
  flex-grow: 1;
  height: 1px;
  background-color: ${({theme}) => theme.colors.greys.dark};
  opacity: 0.65;
  min-width: 10px;
`

// eslint-disable-next-line no-undef
export const StyledCategoryContainer = styled.div<ContainerProps>`
  display: flex;
  flex-wrap: wrap;
  max-height: ${({displayShowMoreText, isShowingMore}) => (displayShowMoreText && !isShowingMore ? "50px" : "none")};
  overflow: hidden;
  transition: max-height 0.5s ease-in-out;

  ${({displayShowMoreText, isShowingMore}) =>
    displayShowMoreText &&
    isShowingMore &&
    css`
      max-height: none;
      overflow: visible;
    `}
`
export const Wrapper = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center; /* center children horizontally */
  margin-top: 4px !important;
  padding-top: 4px !important;
`

export const ShowMoreContainer = styled.div`
  display: flex;
  justify-content: center; /* center horizontally */
  align-items: center; /* center vertically */
  width: 100%;
  cursor: pointer;
  gap: ${({theme}) => theme.spacing.one}; /* spacing between text and icon */
  margin-top: 0 !important;
  padding-top: 0 !important;
  text-align: center;
`

export const ShowMoreText = styled.span`
  ${({theme}) => css`
    color: ${theme.colors.greys.black};
    font-family: ${theme.font.medium};
    font-size: 10px;
    font-weight: bold;
    text-transform: capitalize;
    line-height: 12px;
    display: flex; /* flex helps vertically align text with icon */
    align-items: center; /* vertical alignment */
    justify-content: center; /* horizontal alignment */
    text-align: center;
    margin: 0;
  `}
`

export const Chevron = styled.i`
  padding-left: ${({theme}) => theme.spacing.half};
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 12px; /* optional: ensures size consistent with text */
  line-height: 1;
`
